import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/hooks/auth/useAuth';

const ProtectedRoute = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return isAuthenticated()
    ? <Outlet />
    : <Navigate to="/" replace state={{ from: location }} />;
};

export default ProtectedRoute;
